










































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import DxPopup from 'devextreme-vue/popup';
import DxButton from 'devextreme-vue/button';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import DevExpress from 'devextreme/bundles/dx.all';
import { localize } from '@/core/filters';
import DxTextBox from 'devextreme-vue/text-box';
import { DxScrollView } from 'devextreme-vue/scroll-view';
import ResourceTypesDependences, { StructuredValues, DependanceTypes } from '../types';
import DxAccordion from 'devextreme-vue/accordion';
import CustomItem from './CustomItem.vue';

@Component({
    components: {
        DxPopup,
        DxButton,
        DxTextBox,
        CustomItem,
        DxAccordion,
        DxScrollView
    }
})
export default class ResourceTypesDependencesList extends Vue {
    public visible: boolean = false;
    public dependences: StructuredValues[] = [];

    public show(dependences: ResourceTypesDependences) {
        this.dependences = this.prepaereData(dependences);
        this.visible = true;
    }

    public close() {
        this.visible = false;
    }

    private prepaereData(dependences: ResourceTypesDependences): StructuredValues[] {
        const result: StructuredValues[] = [];

        Object.values(DependanceTypes).forEach(dependanceType => {
            if (isNaN(Number(dependanceType)) && dependences[dependanceType].length > 0) {
                result.push({
                    name: this.localize('ResourceTypesDependencesList_' + dependanceType.toString()),
                    values: dependences[dependanceType]
                });
            }
        });

        return result;
    }

    private get localize() {
        return localize;
    }
}
